import { Component, ViewChild } from '@angular/core';
import { CpmComponent } from '../../cpm/cpm.component';
import { SpecificDataComponent } from '../../specific-data.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-secondary-enrolment-form',
  standalone: true,
  imports: [TranslateModule, CpmComponent],
  templateUrl: './secondary-enrolment-form.component.html',
  styleUrl: './secondary-enrolment-form.component.css'
})
export class SecondaryEnrolmentFormComponent extends SpecificDataComponent {
  @ViewChild(CpmComponent) cpmComponent: CpmComponent;

  constructor() {
    super();
  }

  override isValid(): boolean {
    if(this.cpmComponent && !this.cpmComponent.isValid()) return false;
    return true;
  }

  override getValue() {
    this.specificData.codeComunidad = this.cpmComponent.selectedComunidad?.codigo;
    return this.specificData;
  }
}